import React, { Component } from 'react';
import { Router, Route, Link, History } from 'react-router';
import pubsub from 'pubsub-js';
import { Collapse, Button } from 'react-bootstrap';
import { Translate, Localize } from 'react-redux-i18n';

import SidebarRun from './Sidebar.run';
import checkPermission from '../Common/permissions';
import { resetCurrentPurchaseOrderSidebar } from '../../actions/purchaseOrders_actions';
import {
  ROOT_URL, ROOT_API_URL, isSH, isAP, isOCM, isHO, isJRC, isDAICHEONG, isESC, isNS, isSW, isSV,
  isWAK, isLAP, isAPD, isHMM, isGGI, isSUN, isVAK, isOLG, isTU, isSKH, isGFD, isABCFF, isAGD,
  isLMH, isBRO, isSDR, isCRW, isEKC, isKM, isRebuild, isCPG, isVIP, isCCW, isSC
} from '../../actions/root_url';
import { connect } from 'react-redux';

const isGV = ROOT_API_URL === 'https://gvyummy-scm.truckxi.com/api/' || ROOT_URL === 'https://gvyummy-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isGA = ROOT_URL === 'https://gastage-scm.truckxi.com/api/'|| ROOT_URL === 'https://ga-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbtstage-scm.truckxi.com/api/' || ROOT_URL === 'https://nbtstage-scm.truckxi.com/api/';
const isABC = ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || ROOT_URL === 'https://abc-scm.truckxi.com/api/';

const getActiveClassName = isActive => (isActive ? 'active' : '');
const dashboardList = ['dashboard'];
const purchaseManagementList = [/*'purchaseQuote', 'purchaseTemplate', 'purchaseSchedule', */'purchaseReturn', 'newPurchaseOrder', 'purchaseOrder', 'dropshipOrder', 'purchasingPerformanceReport', 'priceAdjustmentReport', 'purchaseReferenceReport'];
const salesManagementList = ['salesOrders', 'mobileSalesOrders', 'salesInvoice', 'so_packing', 'bolinventory', 'favoriteList', 'groupList', 'wholesale', 'promotions', 'salesPerformanceReport', 'newSalesOrder', 'salesPopularity', 'purchaseStatistics', 'merchantSummary', 'merchantReport', 'multilevelMarketing', 'gvRewards', 'groupBuy', 'groupWholesale'];
const manufacturingManagement = ['MFG', 'MR', 'IB'];
const warehouseManagementList = ['storageInventory', 'inventoriesnew', 'warehouses', 'inventories/repackage', 'inventories/convert', 'inventories/relocation', 'inventories/adjustment', 'scrapRecords', 'putAway', 'inventories/receive', 'inventories/receiveHistory', 'productConvertReport', 'adjustmentInventory', 'shelfLifeStatistics', 'inventoryTransfer'];
const dispatchList = ['drivers', 'shipping', 'editRoutes', 'routing', 'autoRouting'];
const ARAPList = ['AR', 'AP', 'paymentSummary', 'purchasePayment', 'arSalesInvoice', 'salesInvoicePayment', 'generalReport', 'customerStatementMain', 'vendorStatementMain', 'customerStatement', 'vendorStatement', 'mobileCustomerStatement', 'cityReport'];
const returnsList = ['customerReturn', 'inventoryReturn'];
const posManagementList = ['POS', 'POSReport', 'POSOrders', 'POSCredits', 'POSHold', 'giftCardTransaction'];
const generalInformationList = ['products', 'products/new', 'customers', 'contentManagement', 'products/groups', 'products/categories', 'agents', 'vendors', 'paymentTerms', 'priceLevel', 'mobileManagement', 'presidentDashboard', 'packers'];
const rmaList = ['customerRMA', 'dispatchRMA', 'rmaForm'];
const settingList = ['scmUserManagement', 'userManagement', 'groupManagement', 'taxManagement', 'actionLog'];
const MMdriverList = ['mmdriver'];
const aiTools = ['aiChat'];

class Sidebar extends Component {
  static contextTypes = {
    router: React.PropTypes.func.isRequired
  };

  user = localStorage.getItem('userType');

  constructor(props, context) {
    super(props, context);
    this.state = {
      userBlockCollapse: false,
      collapse: {
        users: this.routeActive(['']),
        generalInformation: this.routeActive(['products', 'products/new', 'customers', 'products/groups', 'products/categories', 'agents', 'vendors', 'paymentTerms', 'priceLevel', 'mobileManagement', 'presidentDashboard', 'contentManagement', 'packers']),
        purchaseManagement: this.routeActive([/*'purchaseQuote', 'purchaseTemplate', 'purchaseSchedule', */'purchaseReturn', 'purchaseOrder', 'dropshipOrder', 'purchasingPerformanceReport', 'priceAdjustmentReport', /*'purchasePivotChart', */'purchaseReferenceReport', 'newPurchaseOrder']),
        salesManagement: this.routeActive(['salesOrders', 'mobileSalesOrders', 'newSalesOrder', 'sopacking', 'salesInvoice', 'salesPerformanceReport', 'promotions', 'favoriteList', 'groupList', 'merchantReport', 'multilevelMarketing', 'gvRewards', 'groupBuy', 'groupWholesale']),
        manufacturingManagement: this.routeActive(['MFG', 'MR', 'IB', 'PR', 'outsourced', 'scrap']),
        warehouseManagement: this.routeActive(['storageInventory', 'inventoriesnews', 'warehouses', 'inventories/repackage', 'inventories/convert', 'productConvertReport', 'inventories/receive', 'inventories/receiveHistory', 'putAway', 'inventories/adjustment', 'scrapRecords', "adjustmentInventory", "inventoryTransfer"]),
        dispatch: this.routeActive(['drivers','shipping', 'routing', 'editRoutes', 'autoRouting']),
        setting: this.routeActive(['userManagement', 'groupManagement', 'taxManagement', 'currencyManagement', 'actionLog']),
        rma: this.routeActive(['customerRMA', 'dispatchRMA', 'rmaForm']),
        returns: this.routeActive(['returns', 'customerReturn', 'inventoryReturn']),
        ARAP: this.routeActive(['AR', 'AP', 'paymentSummary', 'purchasePayment', 'arSalesInvoice', 'salesInvoicePayment', 'generalReport', 'customerStatementMain', 'vendorStatementMain', 'mobileCustomerStatement', 'cityReport', 'customerStatement', 'vendorStatement']),
        posManagement: this.routeActive(['POS', 'POSReport']),
        report: this.routeActive(['priceAdjustment', 'productConvert', 'purchasePivot', 'purchaseReference', 'purchasePerformance', 'salesPerformance']),
      }
    };
    this.pubsub_token = pubsub.subscribe('toggleUserblock', () => {
      this.setState({
        userBlockCollapse: !this.state.userBlockCollapse
      });
    });
  };

  componentDidMount() {
    SidebarRun();
  }

  componentWillUnmount() {
    // React removed me from the DOM, I have to unsubscribe from the pubsub using my token
    pubsub.unsubscribe(this.pubsub_token);
  }

  routeActive(paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    for (let p in paths) {
      if (this.context.router.isActive(paths[p]) === true)
        return true;
    }
    return false;
  }

  toggleItemCollapse(stateName) {
    var newCollapseState = {};
    for (let c in this.state.collapse) {
      if (this.state.collapse[c] === true && c !== stateName)
        this.state.collapse[c] = false;
    }
    this.setState({
      collapse: {
        [stateName]: !this.state.collapse[stateName]
      }
    });
  }

    renderESCAside() {
      return (
        <aside className='aside'>
          { /* START Sidebar (left) */ }
          <div className="aside-inner">
            <nav data-sidebar-anyclick-close="" className="sidebar">
              { /* START sidebar nav */ }
              <ul className="nav">
                { /* START user info */ }
                <li className="has-user-block">
                  <Collapse id="user-block" in={ this.state.userBlockCollapse }>
                    <div className="item user-block">
                      { /* User picture */ }
                      <div className="user-block-picture">
                        <div className="user-block-status">
                          <img src="/img/user/02.jpg" alt="Avatar" width="60" height="60" className="img-thumbnail img-circle" />
                          <div className="circle circle-success circle-lg"></div>
                        </div>
                      </div>
                      { /* Name and Job */ }
                      <div className="user-block-info">
                        <span className="user-block-name"><Translate value="user_name" /></span>
                        <span className="user-block-role"><Translate value="user_role" /></span>
                      </div>
                    </div>
                  </Collapse>
                </li>
                { /* END user info */ }
                { /* Iterates over all sidebar items */ }
                <li className={ getActiveClassName(this.routeActive(dashboardList)) }>
                  <Link className="nav-item" to="/dashboard" title="Dashboard">
                    <em className="icon-speedometer" aria-hidden="true"></em>
                    <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="dashboard" /></span>
                  </Link>
                </li>
                <li className={ getActiveClassName(this.routeActive(generalInformationList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'generalInformation') }>
                    <em className="icon-book-open"></em>
                    <span data-localize="sidebar.nav.MENU"><large><Translate value="general_management" /></large></span>
                  </div>
                  <Collapse in={ this.state.collapse.generalInformation } timeout={ 100 }>
                    <ul id="products" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="general_information" /></li>
                      <li className={(this.routeActive('products') ? 'active' : '') + (checkPermission('view_product') ? '' : 'disabled-sidebar')}>
                        <Link to="/products" title="Product">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="product" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('customers') ? 'active' : '') + (checkPermission('view_customer') ? '' : 'disabled-sidebar')}>
                        <Link to="/customers" title="Customers">
                          <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="customers" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('vendors') ? 'active' : '') + (checkPermission('view_vendor') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendors" title="Vendor">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="vendor" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('agents') ? 'active' : '') + (checkPermission('view_agent') ? '' : 'disabled-sidebar')}>
                        <Link to="/agentManagement" title="Agents">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="agents" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('paymentTerms') ? 'active' : '') + (checkPermission('view_payment_term') ? '' : 'disabled-sidebar')}>
                        <Link to="/paymentTerms" title="Payment Term">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="payment_term" /></span>
                        </Link>
                      </li>
                      {/* <li className={(this.routeActive('contentManagement') ? 'active' : '') + (checkPermission('view_content_management') ? '' : 'disabled-sidebar')}>
                        <Link href="/contentManagement" title="Content Management">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="content_management" /></span>
                        </Link>
                      </li> */}
                      <li className={(this.routeActive('fbaAddressManagement') ? 'active' : '') + (checkPermission('view_content_management') ? '' : 'disabled-sidebar')}>
                        <Link href="/fbaAddressManagement" title="FBA Address Management">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="fbaAddressManagement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('products/groups') ? 'active' : '') + (checkPermission('view_product_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/products/groups" title="Product Group">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value={"groups_management"} /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('priceLevel') ? 'active' : '') + (checkPermission('view_price_level') ? '' : 'disabled-sidebar')}>
                        <Link to="/priceLevel" title="Price Level">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="price_level" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('mobileManagement') ? 'active' : '') + (checkPermission('view_product_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/mobileManagement" title="Mobile Management">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="mobile_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('categoryAnalysis') ? 'active' : '') + (checkPermission('view_category_analysis') ? '' : 'disabled-sidebar')}>
                        <Link to="/categoryAnalysis" title="Category Analysis">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="category_analysis"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('presidentDashboard') ? 'active' : '') + (checkPermission('view_dashboard_president') ? '' : 'disabled-sidebar')}>
                        <Link to="/presidentDashboard" title="President Dashboard">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="president_dashboard" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(salesManagementList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'salesManagement') }>
                    <em className="fa fa-bar-chart"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="sales_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.salesManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="sales_management" /></li>
                      <li className={(this.routeActive('newSalesOrder') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesOrders/new" title="New Sales Order">
                          <span data-localize="sidebar.nav.ORDER"><Translate value={"new_sales_order"} /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesOrders') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesOrders" title="Sales Order">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value={"sales_order"} /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('mobileSalesOrders') ? 'active' : '') + (checkPermission('view_mobile_order') ? '' : 'disabled-sidebar')}>
                        <Link to="/mobileSalesOrders" title="Mobile Sales Order">
                          <span data-localize="sidebar.nav.MOBILESALESORDERS"><Translate value="mobile_sales_order" /></span>
                        </Link>
                      </li>
                      {isVAK && this.props.company && this.props.company.value == 6 && <li className={(this.routeActive('pickingList') ? 'active' : '')}>
                          <Link href="/pickingList" title="Picking List">
                            <span data-localize="sidebar.nav.PICKINGLIST"><Translate value="picking_list"/></span>
                          </Link>
                        </li>}
                        {isAGD && <li className={(this.routeActive('pickingList') ? 'active' : '')}>
                          <Link href="/pickingList" title="Picking List">
                            <span data-localize="sidebar.nav.PICKINGLIST"><Translate value="picking_list"/></span>
                          </Link>
                        </li>}
                      <li className={(this.routeActive('salesInvoice') ? 'active' : '') + (checkPermission('view_sales_invoice') ? '' : 'disabled-sidebar')}>
                        <Link href="/salesInvoice" title="Sales Invoice">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="sales_invoice" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('so_packing') ? 'active' : '') + (checkPermission('view_so_packing') ? '' : 'disabled-sidebar')}>
                        <Link href="/sopacking" title="SO Packing">
                          <span data-localize="sidebar.nav.SOPACKING"><Translate value="so_packing" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('bolinventory') ? 'active' : '') + (checkPermission('view_bol_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/bolinventory" title="BOL Inventory">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="bol_inventory" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('promotions') ? 'active' : '') + (checkPermission('view_promotions') ? '' : 'disabled-sidebar')}>
                        <Link to="/promotions" title="Promotion">
                          <span data-localize="sidebar.nav.PROMOTION"><Translate value="promotion" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('favoriteList') ? 'active' : '') + (checkPermission('view_sales_favorites') ? '' : 'disabled-sidebar')}>
                        <Link to="/favoriteList" title="Favorite List">
                          <span data-localize="sidebar.nav.FAVORITELIST"><Translate value="favorites_list" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupList') ? 'active' : '') + (checkPermission('view_group_list') ? '' : 'disabled-sidebar')}>
                        <Link to="/groupList" title="Group List">
                          <span data-localize="sidebar.nav.GROUPLIST"><Translate value="group_list" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesPerformanceReport') ? 'active' : '') + (checkPermission('view_sales_performance') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesPerformanceReport" title="Sales Performance">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="sales_performance" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesPopularity') ? 'active' : '') + (checkPermission('view_sales_popularity') ? '' : 'disabled-sidebar')}>
                        <Link href="/salesPopularity" title="Sales Popularity">
                          <span data-localize="sidebar.nav.POPULARITY"><Translate value="sales_popularity" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchaseStatistics') ? 'active' : '') + (checkPermission('view_purchase_statistics') ? '' : 'disabled-sidebar')}>
                        <Link href="/purchaseStatistics" title="Purchase Statistics">
                          <span data-localize="sidebar.nav.PURCHASESTATISTICS"><Translate value="purchase_statistics" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('merchantSummary') ? 'active' : '') + ((checkPermission('view_merchant_summary')) ? '' : 'disabled-sidebar')}>
                        <Link href="/merchantSummary" title="Merchant Summary">
                          <span data-localize="sidebar.nav.MERCHANTSUMMARY"><Translate value="merchant_summary" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('merchantReport') ? 'active' : '') + (checkPermission('view_merchant_report') ? '' : 'disabled-sidebar')}>
                        <Link href="/merchantReport" title="Merchant Report">
                          <span data-localize="sidebar.nav.MERCHANTREPORT"><Translate value="merchant_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('multilevelMarketing') ? 'active' : '') + (checkPermission('view_multilevel_marketing') ? '' : 'disabled-sidebar')}>
                        <Link href="/multilevelMarketing" title="Multilevel Marketing">
                          <span data-localize="sidebar.nav.MULTILEVELMARKETING"><Translate value="multilevel_marketing" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupBuy') ? 'active' : '') + (checkPermission('view_group_buy') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupBuy" title="Group Buy">
                          <span data-localize="sidebar.nav.GROUPBUY"><Translate value="group_buy" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupWholesale') ? 'active' : '') + (checkPermission('view_group_wholesale') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupWholesale" title="Group Wholesale">
                          <span data-localize="sidebar.nav.GROUPWHOLESALE"><Translate value="group_wholesale" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(returnsList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'returns') }>
                    <em className="fa fa-backward"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="returns" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.returns } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="returns" /></li>
                      <li className={(this.routeActive('customerReturn') ? 'active' : '') + (checkPermission('view_sales_return') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerReturn" title="New Sales Return">
                          <span><Translate value="new_sales_return" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventoryReturn') ? 'active' : '') + (checkPermission('view_sales_return') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventoryReturn" title="Sales Return">
                          <span><Translate value="sales_return" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(warehouseManagementList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'warehouseManagement') }>
                    <em className="fa fa-building"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="warehouse_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.warehouseManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="warehouse_management"/></li>
                      <li className={(this.routeActive('inventoriesnew') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoriesnew" title="Inventory">
                          <span data-localize="sidebar.nav.INVENTORY"><Translate value="inventory"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventoryTransfer') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoryTransfer" title="Inventory Transfer">
                          <span data-localize="sidebar.nav.INVENTORYTRANSFER"><Translate value="inventoryTransfer"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventories/receive') ? 'active' : '') + (checkPermission('view_receive') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventories/receive" title="New Receiving">
                          <span data-localize="sidebar.nav.RECEIVE"><Translate value="new_receiving"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventories/receiveHistory') ? 'active' : '') + (checkPermission('view_receive_history') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventories/receiveHistory" title="Receive History">
                          <span data-localize="sidebar.nav.RECEIVE_HISTORY"><Translate value="receive_history"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('warehouses') ? 'active' : '') + (checkPermission('view_warehouse') ? '' : 'disabled-sidebar')}>
                        <Link to="/warehouses" title="Warehouse">
                          <span data-localize="sidebar.nav.WAREHOUSE"><Translate value="warehouse"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('workingOrders') ? 'active' : '') + ((checkPermission('view_warehouse')) ? '' : 'disabled-sidebar')}>
                        <Link href="/workingOrders" title="Working Orders">
                          <span data-localize="sidebar.nav.WORKING_ORDERS"><Translate value="working_orders"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('newWorkingOrders') ? 'active' : '') + ((checkPermission('view_warehouse')) ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoryConvert" title="New Working Orders">
                          <span data-localize="sidebar.nav.NEW_WORKING_ORDERS"><Translate value="new_working_orders"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('adjustmentInventory') ? 'active' : '') + (checkPermission('view_warehouse') ? '' : 'disabled-sidebar')}>
                        <Link href="/adjustmentInventory" title="Inventory Adjustment">
                          <span data-localize="sidebar.nav.INVENTORY_ADJUSTMENT"><Translate value="inventory_adjustment"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('shelfLifeStatistics') ? 'active' : '') + (checkPermission('view_shelf_life_statistics') ? '' : 'disabled-sidebar')}>
                        <Link href="/shelfLifeStatistics" title="Shelf Life Statistics">
                          <span data-localize="sidebar.nav.SHELFLIFESTATISTICS"><Translate value="shelf_life_statistics"/></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={getActiveClassName(this.routeActive(purchaseManagementList))}>
                  <div className="nav-item" onClick={this.toggleItemCollapse.bind(this, 'purchaseManagement')}>
                    <em className="icon-basket"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="purchase_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.purchaseManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="purchase_management" /></li>
                      <li className={(this.routeActive('newPurchaseOrder') ? 'active' : '') + (checkPermission('add_purchase_order') ? '' : 'disabled-sidebar')}>
                        <Link href="/purchaseOrder/new" title="New Purchase Order">
                          <span data-localize="sidebar.nav.ORDER"><Translate value="new_purchase_order" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchaseOrder') ? 'active' : '') + (checkPermission('view_purchase_order') ? '' : 'disabled-sidebar')}>
                        <Link to="/purchaseOrder" title="Purchase Order">
                          <span data-localize="sidebar.nav.ORDER"><Translate value="purchase_order" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchaseReturn') ? 'active' : '') + (checkPermission('view_purchase_return') ? '' : 'disabled-sidebar')}>
                        <Link to="/purchaseReturn" title="Purchase Return">
                          <span data-localize="sidebar.nav.RETURN"><Translate value="purchase_return" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchasingPerformanceReport') ? 'active' : '') + (checkPermission('view_purchase_performance') ? '' : 'disabled-sidebar')}>
                        <Link to="/purchasingPerformanceReport" title="Purchase Performance">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="purchase_performance" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('priceAdjustmentReport') ? 'active' : '') + (checkPermission('view_price_reference') ? '' : 'disabled-sidebar')}>
                        <Link to="/priceAdjustmentReport" title="Price Reference">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="price_reference" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchaseReferencereport') ? 'active' : '') + (checkPermission('view_purchase_reference') ? '' : 'disabled-sidebar')}>
                        <Link href="/purchaseReferencereport" title="Purchase Reference">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="purchase_reference" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(dispatchList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'dispatch') }>
                    <em className="fa fa-truck"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="dispatch" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.dispatch } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="dispatch" /></li>
                      <li className={(this.routeActive('routing') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                        <Link to="/routing" title="Routing">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value="routing" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('autoRouting') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                        <Link to="/autoRouting" title="Auto Routing">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value="auto_routing" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('editRoutes') ? 'active' : '') + (checkPermission('view_edit_route') ? '' : 'disabled-sidebar')}>
                        <Link to="/editRoutes" title="Edit Route">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value="edit_route" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('shipping') ? 'active' : '') + (checkPermission('view_shipping') ? '' : 'disabled-sidebar')}>
                        <Link to="/shipping" title="Shipping">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value="shipping" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('drivers') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                        <Link to="/drivers" title="Drivers">
                          <span data-localize="sidebar.nav.SALESORDERS"><Translate value="drivers" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(ARAPList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'ARAP') }>
                    <em className="fa fa-credit-card"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="ar_slashsign_ap" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.ARAP } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="AR" /></li>
                      <li className={(this.routeActive('AR') ? 'active' : '') + (checkPermission('view_account_receivable') ? '' : 'disabled-sidebar')}>
                        <Link href="/AR" title="Accounts Receivable">
                          <span data-localize="sidebar.nav.AR"><Translate value="account_receivable" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('AP') ? 'active' : '') + (checkPermission('view_account_payable') ? '' : 'disabled-sidebar')}>
                        <Link href="/AP" title="Accounts Payable">
                          <span data-localize="sidebar.nav.AP"><Translate value="account_payable" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('/paymentSummary') ? 'active' : '') + (checkPermission('view_payment_summary') ? '' : 'disabled-sidebar')}>
                        <Link href="/paymentSummary" title="Payment Summary">
                          <span data-localize="sidebar.nav.AP"><Translate value="payment_summary" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchasePayment') ? 'active' : '') + (checkPermission('view_purchase_payment') ? '' : 'disabled-sidebar')}>
                        <Link to="/purchasePayment" title="Purchase Report">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="purchase_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('arSalesInvoice') ? 'active' : '') + ((checkPermission('view_sales_invoice')) ? '' : 'disabled-sidebar')}>
                        <Link to="/arSalesInvoice" title="Sales Invoice">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="sales_invoice" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesInvoicePayment') ? 'active' : '') + (checkPermission('view_sales_report') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesInvoicePayment" title="Sales Report">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="sales_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('generalReport') ? 'active' : '') + (checkPermission('view_general_report') ? '' : 'disabled-sidebar')}>
                        <Link to="/generalReport" title="General Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="general_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('customerStatementMain') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerStatementMain" title="AR Aged Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="ar_aged_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('vendorStatementMain') ? 'active' : '') + (checkPermission('view_vendor_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendorStatementMain" title="AP Aged Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="ap_aged_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('customerStatement') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerStatement" title="Customer Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="customer_statement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('vendorStatement') ? 'active' : '') + (checkPermission('view_vendor_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendorStatement" title="Vendor Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="vendor_statement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('cityReport') ? 'active' : '') + ((checkPermission('view_city_report') ? '' : 'disabled-sidebar'))}>
                        <Link to="/cityReport" title="City Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="city_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('mobileCustomerStatement') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/mobileCustomerStatement" title="Mobile Customer Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="mobile_customer_statement" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(posManagementList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'posManagement') }>
                    <em className="fa fa-bar-chart"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="pos_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.posManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="pos_management" /></li>
                      <li className={(this.routeActive('POS') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                        <Link to="/pos" title="POS">
                          <span><Translate value="pos" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('POSReport') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                        <Link to="/posReport" title="POS Report">
                          <span><Translate value="pos_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('POSOrders') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                        <Link to="/posOrders" title="POS Orders">
                          <span data-localize="sidebar.nav.POSORDERS"><Translate value="pos_order" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('POSCredits') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                        <Link to="/posCredits" title="POS Credits">
                          <span data-localize="sidebar.nav.CREDITS"><Translate value="pos_credit" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('POSHold') ? 'active' : '')}>
                        <Link to="/posHolds" title="POS Holds">
                          <span data-localize="sidebar.nav.HOLDS"><Translate value="pos_holds" /></span>
                        </Link>
                      </li>
                      {isGFD &&
                      <li className={(this.routeActive('giftCardTransaction') ? 'active' : '')}>
                        <Link href="/giftCardTransaction" title="Gift Card Transactions">
                          <span data-localize="sidebar.nav.GIFTCARD"><Translate value="gift_card_transactions" /></span>
                        </Link>
                      </li>
                      }
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(rmaList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'rma') }>
                    <em className="fa fa-recycle"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="rma" /></span>
                  </div>
                  <Collapse in={this.state.collapse.rma} timeout={100}>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                      <li className={(this.routeActive('customerRMA') ? 'active' : '') + (checkPermission('view_bd_rma_customer') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerRMA" title="RMA Form">
                          <span data-localize="sidebar.nav.RMAFORM"><Translate value="customer_rma" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('dispatchRMA') ? 'active' : '') + (checkPermission('view_bd_rma') ? '' : 'disabled-sidebar')}>
                        <Link to="/dispatchRMA" title="Dispatch RMA">
                          <span data-localize="sidebar.nav.DISPATCHRMA"><Translate value="dispatch_rma" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {!isRebuild &&
                <li className={ getActiveClassName(this.routeActive(settingList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'setting') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="admin_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.setting } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                      <li className={(this.routeActive('userManagement') ? 'active' : '') + (checkPermission('view_baseuser') ? '' : 'disabled-sidebar')}>
                        <Link to="/userManagement" title="User Management">
                          <span data-localize="sidebar.nav.USERMANAGEMENT"><Translate value="user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupManagement') ? 'active' : '') + (checkPermission('view_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/groupManagement" title="Role Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="role_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('taxManagement') ? 'active' : '') + (checkPermission('view_tax_area') ? '' : 'disabled-sidebar')}>
                        <Link to="/taxManagement" title="Tax Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="tax_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('currencyManagement') ? 'active' : '') + (checkPermission('view_currency') ? '' : 'disabled-sidebar')}>
                        <Link to="/currencyManagement" title="Currency Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="currency_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('actionLog') ? 'active' : '') + (checkPermission('view_action_log') ? '' : 'disabled-sidebar')}>
                        <Link to="/actionLog" title="Action Log">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="action_log" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                }
                {isRebuild &&
                <li className={ getActiveClassName(this.routeActive(settingList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'setting') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="admin_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.setting } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                      <li className={(this.routeActive('scmUserManagement') ? 'active' : '') + (checkPermission('view_baseuser') ? '' : 'disabled-sidebar')}>
                        <Link href="/scmUserManagement" title="User Management">
                          <span data-localize="sidebar.nav.SCMUSERMANAGEMENT"><Translate value="scm_user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('userManagement') ? 'active' : '') + (checkPermission('view_baseuser') ? '' : 'disabled-sidebar')}>
                        <Link to="/userManagement" title="User Management">
                          <span data-localize="sidebar.nav.USERMANAGEMENT"><Translate value="mobile_user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupManagement') ? 'active' : '') + (checkPermission('view_group') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupManagement" title="Role Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="role_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('taxManagement') ? 'active' : '') + (checkPermission('view_tax_area') ? '' : 'disabled-sidebar')}>
                        <Link href="/taxManagement" title="Tax Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="tax_management" /></span>
                        </Link>
                      </li>
                      {/* <li className={(this.routeActive('currencyManagement') ? 'active' : '') + (checkPermission('view_currency') ? '' : 'disabled-sidebar')}>
                        <Link to="/currencyManagement" title="Currency Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="currency_management" /></span>
                        </Link>
                      </li> */}
                      <li className={(this.routeActive('actionLog') ? 'active' : '') + (checkPermission('view_action_log') ? '' : 'disabled-sidebar')}>
                        <Link href="/actionLog" title="Action Log">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="action_log" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                }
                <li className={ getActiveClassName(this.routeActive(MMdriverList)) }>
                  <Link to="/mmdriver" title="MMdriver">
                    <em className="fa fa-truck"></em>
                    <span data-localize="sidebar.nav.RMAFORM"><Translate value="MMdriver" /></span>
                  </Link>
                </li>
                <li className={ getActiveClassName(this.routeActive(aiTools)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'aiTools') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="ai_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.aiTools } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="ai_tools" /></li>
                      <li className={(this.routeActive('aiChat') ? 'active' : '') + (checkPermission('view_ai') ? '' : 'disabled-sidebar')}>
                        <Link href="/aiChat" title="AI CHAT">
                          <span data-localize="sidebar.nav.AICHAT"><Translate value="ai_chat" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
              </ul>
              { /* END sidebar nav */ }
            </nav>
          </div>
          { /* END Sidebar (left) */ }
        </aside>
      );
    }

    renderDefaultAside() {
      return (
        <aside className='aside'>
          { /* START Sidebar (left) */ }
          <div className="aside-inner">
            <nav data-sidebar-anyclick-close="" className="sidebar">
              { /* START sidebar nav */ }
              <ul className="nav">
                { /* START user info */ }
                <li className="has-user-block">
                  <Collapse id="user-block" in={ this.state.userBlockCollapse }>
                    <div className="item user-block">
                      { /* User picture */ }
                      <div className="user-block-picture">
                        <div className="user-block-status">
                          <img src="/img/user/02.jpg" alt="Avatar" width="60" height="60" className="img-thumbnail img-circle" />
                          <div className="circle circle-success circle-lg"></div>
                        </div>
                      </div>
                      { /* Name and Job */ }
                      <div className="user-block-info">
                        <span className="user-block-name"><Translate value="user_name" /></span>
                        <span className="user-block-role"><Translate value="user_role" /></span>
                      </div>
                    </div>
                  </Collapse>
                </li>
                { /* END user info */ }
                { /* Iterates over all sidebar items */ }

                <li className={ getActiveClassName(this.routeActive(dashboardList)) }>
                  <Link className="nav-item" to="/dashboard" title="Dashboard">
                    <em className="icon-speedometer" aria-hidden="true"></em>
                    <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="dashboard" /></span>
                  </Link>
                </li>
                {
                  !isWIZ &&
                  <li className={ getActiveClassName(this.routeActive(purchaseManagementList)) }>
                    <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'purchaseManagement') }>
                      <em className="icon-basket"></em>
                      <span data-localize="sidebar.nav.MENU"><Translate value="purchase_management" /></span>
                    </div>
                    <Collapse in={ this.state.collapse.purchaseManagement } timeout={ 100 }>
                      <ul id="quote" className="nav sidebar-subnav">
                        <li className="sidebar-subnav-header"><Translate value="purchase_management" /></li>
                        {(isOCM || isNS || isGFD) && <li className={(this.routeActive('newPrepareOrder') ? 'active' : '') + (checkPermission('add_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/prepareOrder/new" title="New Prepare Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={"new_prepare_order"} /></span>
                          </Link>
                        </li>}
                        {(isOCM || isNS || isGFD) && <li className={(this.routeActive('prepareOrder') ? 'active' : '') + (checkPermission('view_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/prepareOrder" title="Prepare Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={"prepare_order"} /></span>
                          </Link>
                        </li>}
                        {/* isSH has seperate permission */}
                        {(isSH || isAP) && <li className={(this.routeActive('newPrepareOrder') ? 'active' : '') + (checkPermission('add_prepare_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/prepareOrder/new" title="New Prepare Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={"new_purchase_order"} /></span>
                          </Link>
                        </li>}
                        {(isSH || isAP) && <li className={(this.routeActive('prepareOrder') ? 'active' : '') + (checkPermission('view_prepare_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/prepareOrder" title="Prepare Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={"purchase_order"} /></span>
                          </Link>
                        </li>}
                        {isGFD && (
                        <li className={(this.routeActive('newPurchaseOrder') ? 'active' : '') + (checkPermission('add_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/purchaseOrderQuote/new" title="New Purchase Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value="new_purchase_order_quote" /></span>
                          </Link>
                        </li>
                        )}
                        {isGFD && (
                        <li className={(this.routeActive('newPurchaseOrder') ? 'active' : '') + (checkPermission('add_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/purchaseOrderQuote" title="Purchase Order Quote">
                            <span data-localize="sidebar.nav.ORDER"><Translate value="purchase_order_quote" /></span>
                          </Link>
                        </li>
                        )}
                        <li className={(this.routeActive('newPurchaseOrder') ? 'active' : '') + (checkPermission('add_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/purchaseOrder/new" title="New Purchase Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={(isSH || isAP) ? "new_shipping_advice" : "new_purchase_order"} /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('purchaseOrder') ? 'active' : '') + (checkPermission('view_purchase_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/purchaseOrder" title="Purchase Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={(isSH || isAP) ? "shipping_advice" : "purchase_order"} /></span>
                          </Link>
                        </li>

                        {(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? <li className={(this.routeActive('dropshipOrder') ? 'active' : '') + (checkPermission('view_dropship_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/dropshipOrder" title="Dropship Order">
                            <span data-localize="sidebar.nav.ORDER"><Translate value="dropship_order" /></span>
                          </Link>
                        </li> : null }
                        {/*
                          <li className={ this.routeActive('purchaseQuote') ? 'active' : '' }>
                            <Link to="/purchaseQuote" title="Purchase Quote">
                                <span data-localize="sidebar.nav.QUOTE"><Translate value="purchase_quote" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('purchaseTemplate') ? 'active' : '' }>
                              <Link to="/purchaseTemplate" title="Purchase Template">
                                <span data-localize="sidebar.nav.TEMPLATE"><Translate value="purchase_template" /></span>
                              </Link>
                          </li>
                          <li className={ this.routeActive('purchaseSchedule') ? 'active' : '' }>
                              <Link to="/purchaseSchedule" title="Purchase Schedule">
                                  <span data-localize="sidebar.nav.SCHEDULE"><Translate value="purchase_schedule" /></span>
                              </Link>
                          </li>
                        */}
                        <li className={(this.routeActive('purchaseReturn') ? 'active' : '') + (checkPermission('view_purchase_return') ? '' : 'disabled-sidebar')}>
                          <Link to="/purchaseReturn" title="Purchase Return">
                            <span data-localize="sidebar.nav.RETURN"><Translate value="purchase_return" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('purchasingPerformanceReport') ? 'active' : '') + (checkPermission('view_purchase_performance') ? '' : 'disabled-sidebar')}>
                          <Link to="/purchasingPerformanceReport" title="Purchase Performance">
                            <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="purchase_performance" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('priceAdjustmentReport') ? 'active' : '') + (checkPermission('view_price_reference') ? '' : 'disabled-sidebar')}>
                          <Link to="/priceAdjustmentReport" title="Price Reference">
                            <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="price_reference" /></span>
                          </Link>
                        </li>
                        {/*
                          <li className={ this.routeActive('purchasePivotChart') ? 'active' : '' }>
                              <Link to="/purchasePivotChart" title="Quote Reference">
                                  <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="quote_reference" /></span>
                              </Link>
                          </li>
                        */}
                        <li className={(this.routeActive('purchaseReferencereport') ? 'active' : '') + (checkPermission('view_purchase_reference') ? '' : 'disabled-sidebar')}>
                          <Link href="/purchaseReferencereport" title="Purchase Reference">
                            <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="purchase_reference" /></span>
                          </Link>
                        </li>
                      </ul>
                    </Collapse>
                  </li>
                }
                <li className={ getActiveClassName(this.routeActive(salesManagementList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'salesManagement') }>
                    <em className="fa fa-bar-chart"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="sales_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.salesManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="sales_management" /></li>
                      {
                        (isLAP || isAPD) && <li className={(this.routeActive('newSalesQuote') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/salesQuotes/new" title="New Sales Quote">
                            <span data-localize="sidebar.nav.ORDER"><Translate value={'new_sales_quote'}/></span>
                          </Link>
                        </li>
                      }
                      {
                        (isLAP || isAPD) && <li className={(this.routeActive('salesQuotes') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/salesQuotes" title="Sales Order">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value={"sales_quote"} /></span>
                          </Link>
                        </li>
                      }
                      <li className={(this.routeActive('newSalesOrder') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                        {
                          isGA ? (
                            <Link href="/salesOrders/new" title="New Sales Order">
                              <span data-localize="sidebar.nav.ORDER"><Translate value={(isDSQ || isWIZ || isFJ || isJTB || isABCFF) ? "new_inbound_order" : "new_sales_order"} /></span>
                            </Link>
                          ) : (
                            <Link to="/salesOrders/new" title="New Sales Order">
                              <span data-localize="sidebar.nav.ORDER"><Translate value={(isDSQ || isWIZ || isFJ || isJTB || isABCFF) ? "new_inbound_order" : "new_sales_order"} /></span>
                            </Link>
                          )
                        }
                      </li>
                      <li className={(this.routeActive('salesOrders') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                        {
                          isGA ? (
                            <Link href="/salesOrders" title="Sales Order">
                              <span data-localize="sidebar.nav.SALESORDERS"><Translate value={(isDSQ || isWIZ || isFJ || isJTB || isABCFF) ? "inbound_order" : "sales_order"} /></span>
                            </Link>
                          ) : (
                            <Link to="/salesOrders" title="Sales Order">
                              <span data-localize="sidebar.nav.SALESORDERS"><Translate value={(isDSQ || isWIZ || isFJ || isJTB || isABCFF) ? "inbound_order" : "sales_order"} /></span>
                            </Link>
                          )
                        }
                      </li>
                      {
                        isABC &&
                        <li className={(this.routeActive('inboundOrdersABC') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/inboundOrdersABC" title="Inbound Order">
                            <span data-localize="sidebar.nav.INBOUNDORDER"><Translate value="inbound_order" /></span>
                          </Link>
                        </li>
                      }
                      {
                        isABC &&
                        <li className={(this.routeActive('outboundOrdersABC') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link href="/outboundOrdersABC" title="Outbound Order">
                            <span data-localize="sidebar.nav.OUTBOUNDORDER"><Translate value="outbound_order" /></span>
                          </Link>
                        </li>
                      }
                      {
                        isGA && (
                          <li className={(this.routeActive('this_dont_matter') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                            <Link href="/exportOrder/new" title="New Export Order">
                              <span data-localize="sidebar.nav.NEWEXPORTORDER"><Translate value="new_export_order" /></span>
                            </Link>
                          </li>
                        )
                      }
                      {
                        isGA && (
                          <li className={(this.routeActive('this_dont_matter') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                            <Link href="/exportOrder" title="Export Orders">
                              <span data-localize="sidebar.nav.EXPORTORDERS"><Translate value="export_order" /></span>
                            </Link>
                          </li>
                        )
                      }
                      {(isDSQ || isWIZ || isFJ || isJTB || isABCFF) &&
                        <li className={(this.routeActive('newOutboundOrder') ? 'active' : '') + (checkPermission('add_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/outboundOrders/new" title="New Sales Order">
                            <span data-localize="sidebar.nav.NEWOUTBOUNDORDER"><Translate value="new_outbound_order" /></span>
                          </Link>
                        </li>
                      }
                      {(isDSQ || isWIZ || isFJ || isJTB || isABCFF) &&
                        <li className={(this.routeActive('outboundOrders') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/outboundOrders" title="Outbound Order">
                            <span data-localize="sidebar.nav.OUTBOUNDORDER"><Translate value="outbound_order" /></span>
                          </Link>
                        </li>
                      }

                      { !(isDSQ || isFJ || isJTB || isSV || isABCFF) &&
                        <li className={(this.routeActive('mobileSalesOrders') ? 'active' : '') + (checkPermission('view_mobile_order') ? '' : 'disabled-sidebar')}>
                          <Link to="/mobileSalesOrders" title="Mobile Sales Order">
                            <span data-localize="sidebar.nav.MOBILESALESORDERS"><Translate value="mobile_sales_order" /></span>
                          </Link>
                        </li>
                      }
                       {isVAK && this.props.company && this.props.company.value == 6 && <li className={(this.routeActive('pickingList') ? 'active' : '')}>
                          <Link href="/pickingList" title="Picking List">
                            <span data-localize="sidebar.nav.PICKINGLIST"><Translate value="picking_list"/></span>
                          </Link>
                        </li>}
                        {isAGD && <li className={(this.routeActive('pickingList') ? 'active' : '')}>
                          <Link href="/pickingList" title="Picking List">
                            <span data-localize="sidebar.nav.PICKINGLIST"><Translate value="picking_list"/></span>
                          </Link>
                        </li>}
                      <li className={(this.routeActive('salesInvoice') ? 'active' : '') + (checkPermission('view_sales_invoice') ? '' : 'disabled-sidebar')}>
                        <Link href="/salesInvoice" title="Sales Invoice">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="sales_invoice" /></span>
                        </Link>
                      </li>
                      {
                        isGA && <li className={(this.routeActive('quotes') ? 'active' : '') + (checkPermission('view_sales_invoice') ? '' : 'disabled-sidebar')}>
                          <Link href="/quotes" title="Quotes">
                            <span data-localize="sidebar.nav.QUOTES"><Translate value="quotes" /></span>
                          </Link>
                        </li>
                      }
                      <li className={(this.routeActive('so_packing') ? 'active' : '') + (checkPermission('view_so_packing') ? '' : 'disabled-sidebar')}>
                        <Link href="/sopacking" title="SO Packing">
                          <span data-localize="sidebar.nav.SOPACKING"><Translate value="so_packing" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('bolinventory') ? 'active' : '') + (checkPermission('view_bol_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/bolinventory" title="BOL Inventory">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="bol_inventory" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('promotions') ? 'active' : '') + (checkPermission('view_promotions') ? '' : 'disabled-sidebar')}>
                        <Link to="/promotions" title="Promotion">
                          <span data-localize="sidebar.nav.PROMOTION"><Translate value="promotion" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('favoriteList') ? 'active' : '') + (checkPermission('view_sales_favorites') ? '' : 'disabled-sidebar')}>
                        <Link to="/favoriteList" title="Favorite List">
                          <span data-localize="sidebar.nav.FAVORITELIST"><Translate value="favorites_list" /></span>
                        </Link>
                      </li>
                      {/* <li className={this.routeActive('groupList') ? 'active' : ''}> */}
                      <li className={(this.routeActive('groupList') ? 'active' : '') + (checkPermission('view_group_list') ? '' : 'disabled-sidebar')}>
                        <Link to="/groupList" title="Group List">
                          <span data-localize="sidebar.nav.GROUPLIST"><Translate value="group_list" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesPerformanceReport') ? 'active' : '') + (checkPermission('view_sales_performance') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesPerformanceReport" title="Sales Performance">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="sales_performance" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesPopularity') ? 'active' : '') + (checkPermission('view_sales_popularity') ? '' : 'disabled-sidebar')}>
                        <Link href="/salesPopularity" title="Sales Popularity">
                          <span data-localize="sidebar.nav.POPULARITY"><Translate value="sales_popularity" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchaseStatistics') ? 'active' : '') + (checkPermission('view_purchase_statistics') ? '' : 'disabled-sidebar')}>
                        <Link href="/purchaseStatistics" title="Purchase Statistics">
                          <span data-localize="sidebar.nav.PURCHASESTATISTICS"><Translate value="purchase_statistics" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('merchantSummary') ? 'active' : '') + ((checkPermission('view_merchant_summary') && !isGGI) ? '' : 'disabled-sidebar')}>
                        <Link href="/merchantSummary" title="Merchant Summary">
                          <span data-localize="sidebar.nav.MERCHANTSUMMARY"><Translate value="merchant_summary" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('merchantReport') ? 'active' : '') + (checkPermission('view_merchant_report') ? '' : 'disabled-sidebar')}>
                        <Link href="/merchantReport" title="Merchant Report">
                          <span data-localize="sidebar.nav.MERCHANTREPORT"><Translate value="merchant_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('multilevelMarketing') ? 'active' : '') + (checkPermission('view_multilevel_marketing') ? '' : 'disabled-sidebar')}>
                        <Link href="/multilevelMarketing" title="Multilevel Marketing">
                          <span data-localize="sidebar.nav.MULTILEVELMARKETING"><Translate value="multilevel_marketing" /></span>
                        </Link>
                      </li>
                      {
                        isGV &&
                        <li className={(this.routeActive('gvRewards') ? 'active' : '') + (checkPermission('view_gv_rewards') ? '' : 'disabled-sidebar')}>
                          <Link href="/gvRewards" title="GV Rewards">
                            <span data-localize="sidebar.nav.GVREWARDS"><Translate value="gv_rewards" /></span>
                          </Link>
                        </li>
                      }
                      {
                        isNBT &&
                        <li className={(this.routeActive('gvRewards') ? 'active' : '') + (checkPermission('view_gv_rewards') ? '' : 'disabled-sidebar')}>
                          <Link href="/gvRewards" title="NBT Rewards">
                            <span data-localize="sidebar.nav.NBTREWARDS"><Translate value="nbt_rewards" /></span>
                          </Link>
                        </li>
                      }
                      <li className={(this.routeActive('groupBuy') ? 'active' : '') + (checkPermission('view_group_buy') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupBuy" title="Group Buy">
                          <span data-localize="sidebar.nav.GROUPBUY"><Translate value="group_buy" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupWholesale') ? 'active' : '') + (checkPermission('view_group_wholesale') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupWholesale" title="Group Wholesale">
                          <span data-localize="sidebar.nav.GROUPWHOLESALE"><Translate value="group_wholesale" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {
                  isVAK &&
                  <li className={getActiveClassName(this.routeActive(manufacturingManagement))} >
                    <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'manufacturingManagement') }>
                      <em className="fa fa-cogs"></em>
                      <span data-localize="sidebar.nav.MENU"><Translate value="mfg_management" /></span>
                    </div>
                    <Collapse in={ this.state.collapse.manufacturingManagement } timeout={ 100 }>
                      <ul className="nav sidebar-subnav">
                        {this.props.company && this.props.company.value == 1 && <li className={(this.routeActive('MFG') ? 'active' : '') + (checkPermission('view_mfg') ? '' : 'disabled-sidebar')}>
                          <Link href="/MFG" title="MFG Orders">
                            <span data-localize="sidebar.nav.MFGORDERS"><Translate value="mfg_orders"/></span>
                          </Link>
                        </li>}
                        <li className={(this.routeActive('MR') ? 'active' : '') + (checkPermission('view_mr') ? '' : 'disabled-sidebar')}>
                          <Link href="/MR" title="MR Orders">
                            <span data-localize="sidebar.nav.MRORDERS"><Translate value="material_req"/></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('IB') ? 'active' : '') + (checkPermission('view_inbound') ? '' : 'disabled-sidebar')}>
                          <Link href="/IB" title="Inbound Orders">
                            <span data-localize="sidebar.nav.IBORDERS"><Translate value="inbound_orders"/></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('PR') ? 'active' : '') + (checkPermission('view_pr') || checkPermission('req_view_pr') ? '' : 'disabled-sidebar')}>
                          <Link href="/PR" title="PR Orders">
                            <span data-localize="sidebar.nav.PRORDERS"><Translate value="purchase_req"/></span>
                          </Link>
                        </li>
                        {this.props.company && this.props.company.value == 1 && <li className={(this.routeActive('outsourced') ? 'active' : '') + (checkPermission('view_out') ? '' : 'disabled-sidebar')}>
                          <Link href="/outsourced" title="Outsourced Order">
                            <span data-localize="sidebar.nav.OUTSOURCED"><Translate value="outsourced_orders"/></span>
                          </Link>
                        </li>}
                        <li className={(this.routeActive('scrap') ? 'active' : '') + (checkPermission('view_mfg_scrap') ? '' : 'disabled-sidebar')}>
                          <Link href="/scrap" title="Scrap">
                            <span data-localize="sidebar.nav.SCRAP"><Translate value="scrap_orders"/></span>
                          </Link>
                        </li>
                        {this.props.company && this.props.company.value == 1 && <li className={(this.routeActive('bom') ? 'active' : '') + (checkPermission('view_bom') ? '' : 'disabled-sidebar')}>
                          <Link href="/BOM" title="BOM">
                            <span data-localize="sidebar.nav.BOM"><Translate value="bom"/></span>
                          </Link>
                        </li>}
                      </ul>
                    </Collapse>
                  </li>
                }
                <li className={getActiveClassName(this.routeActive(warehouseManagementList))}>
                  <div className="nav-item" onClick={this.toggleItemCollapse.bind(this, 'warehouseManagement')}>
                    <em className="fa fa-building"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="warehouse_management" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.warehouseManagement } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="warehouse_management" /></li>
                      <li className={(this.routeActive('inventoriesnew') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoriesnew" title="Inventory">
                          <span data-localize="sidebar.nav.INVENTORY"><Translate value="inventory" /></span>
                        </Link>
                      </li>
                      {(isOCM || isDAICHEONG || isHMM || isEKC || isLMH || isBRO || isGFD || isSDR || isCRW || isSC || isSUN || isTU || isHO || isJRC || isSKH || isSW || isCPG || isCCW) && <li className={(this.routeActive('inventoryHistory') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoryHistory" title="Inventory History">
                          <span data-localize="sidebar.nav.INVENTORYHISTORY"><Translate value="inventory_history" /></span>
                        </Link>
                      </li>}
                      {
                        ((isLAP || isAPD) || isGFD) && <li className={(this.routeActive('processingOrder') ? 'active' : '') + (true ? '' : 'disabled-sidebar')}>
                          <Link href="/processingOrder" title="Processing Order">
                            <span data-localize="sidebar.nav.PROCESSINGORDER"><Translate value="processing_order"/></span>
                          </Link>
                        </li>
                      }
                      {(isWIZ || isDSQ || isFJ || isJTB || isABCFF) && <li className={(this.routeActive('storageInventory') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                        <Link href="/storageInventory" title="Storage Inventory">
                          <span data-localize="sidebar.nav.STORAGEINVENTORY"><Translate value="storage_inventory" /></span>
                        </Link>
                      </li>}
                      <li className={(this.routeActive('inventoryTransfer') ? 'active' : '') + (checkPermission('view_inventory_transfer') ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoryTransfer" title="Inventory Transfer">
                          <span data-localize="sidebar.nav.INVENTORYTRANSFER"><Translate value="inventoryTransfer" /></span>
                        </Link>
                      </li>
                      {
                        isKM &&
                        <li className={(this.routeActive('customerInventory') ? 'active' : '') + (checkPermission('view_inventory') ? '' : 'disabled-sidebar')}>
                          <Link href="/customerInventory" title="Customer Inventory">
                            <span data-localize="sidebar.nav.CUSTOMER_INVENTORY"><Translate value="customer_inventory" /></span>
                          </Link>
                        </li>
                      }
                      <li className={(this.routeActive('inventories/receive') ? 'active' : '') + (checkPermission('view_receive') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventories/receive" title="New Receiving">
                          <span data-localize="sidebar.nav.RECEIVE"><Translate value="new_receiving" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventories/receiveHistory') ? 'active' : '') + (checkPermission('view_receive_history') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventories/receiveHistory" title="Receive History">
                          <span data-localize="sidebar.nav.RECEIVE_HISTORY"><Translate value="receive_history" /></span>
                        </Link>
                      </li>
                      {/* }<li className={ this.routeActive('putAway') ? 'active' : '' }>
                                          <Link to="/putAway" title="Put Away">
                                              <span data-localize="sidebar.nav.PUT_AWAY"><Translate value="put_away" /></span>
                                          </Link>
                                      </li> */}
                      {/* <li className={(this.routeActive('inventories/repackage') ? 'active' : '') + (checkPermission('view_repackage') ? '' : 'disabled-sidebar')}>
                                          <Link to="/inventories/repackage" title="Inventory Repackage">
                                              <span data-localize="sidebar.nav.INVENTORY_REPACKAGES"><Translate value="inventory_repackage" /></span>
                                          </Link>
                                      </li> */}
                      {/* <li className={ this.routeActive('inventories/convert') ? 'active' : '' }>
                                          <Link to="/inventories/convert" title="Inventory Convert">
                                              <span data-localize="sidebar.nav.INVENTORY_CONVERT"><Translate value="inventory_convert" /></span>
                                          </Link>
                                      </li> */}
                      {/*tempororily disabled due to not working */}
                      {/* <li className={(this.routeActive('inventories/relocation') ? 'active' : '') + (checkPermission('view_inventory_relocation') ? '' : 'disabled-sidebar')}>
                                          <Link to="/inventories/relocation" title="Inventory Relocation">
                                              <a><span data-localize="sidebar.nav.INVENTORY_RELOCATION"><Translate value="inventory_relocation" /></span></a>
                                          </Link>
                                      </li> */}
                      {/* <li className={(this.routeActive('inventories/adjustment') ? 'active' : '') + (checkPermission('view_inventory_adjustment') ? '' : 'disabled-sidebar')}>
                                          <Link to="/inventories/adjustment" title="Inventory Adjustment">
                                            <span data-localize="sidebar.nav.INVENTORY_ADJUSTMENT"><Translate value="inventory_adjustment" /></span>
                                          </Link>
                                      </li> */}
                      {/*tempororily disabled due to not working*/}
                      {/* <li className={(this.routeActive('scrapRecords') ? 'active' : '') + (checkPermission('view_warehouse_scrap') ? '' : 'disabled-sidebar')}>
                                          <Link to="/scrapRecords" title="Scrap Records">
                                              <a><span data-localize="sidebar.nav.SCRAP_RECORDS"><Translate value="scrap_records" /></span></a>
                                          </Link>
                                      </li> */}
                      {/*tempororily disabled due to not working*/}
                      {/* <li className={(this.routeActive('salesOrders') ? 'active' : '') + (checkPermission('view_sales_order') ? '' : 'disabled-sidebar')}>
                                          <Link to="/salesOrders" title="salesOrders">
                                              <a><span data-localize="sidebar.nav.SALESORDERS"><Translate value="outbound" /></span></a>
                                          </Link>
                                      </li> */}
                      <li className={(this.routeActive('warehouses') ? 'active' : '') + (checkPermission('view_warehouse') ? '' : 'disabled-sidebar')}>
                        <Link to="/warehouses" title="Warehouse">
                          <span data-localize="sidebar.nav.WAREHOUSE"><Translate value="warehouse" /></span>
                        </Link>
                      </li>
                      {/* <li className={(this.routeActive('productConvertReport') ? 'active' : '') + (checkPermission('view_product_convert') ? '' : 'disabled-sidebar')}>
                                          <Link to="/productConvertReport" title="Product Convert">
                                              <span data-localize="sidebar.nav.WAREHOUSE"><Translate value="product_convert" /></span>
                                          </Link>
                                      </li> */}
                      {/* Rebuild SCM new pages */}
                      {
                        (isLAP || isAPD) && <li className={(this.routeActive('willCallOrder') ? 'active' : '') + (true ? '' : 'disabled-sidebar')}>
                          <Link href="/willCallOrder" title="Will Call Order">
                            <span data-localize="sidebar.nav.WILLCALLORDER"><Translate value="will_call_orders"/></span>
                          </Link>
                        </li>
                      }
                      {
                        isCCW && <li className={(this.routeActive('transferOrder') ? 'active' : '') + (true ? '' : 'disabled-sidebar')}>
                          <Link href="/transferOrder" title="Transfer Order">
                            <span data-localize="sidebar.nav.TRANSFERORDER"><Translate value="transfer_order"/></span>
                          </Link>
                        </li>
                      }
                      <li className={(this.routeActive('workingOrders') ? 'active' : '') + ((checkPermission('view_warehouse') && !isGGI) ? '' : 'disabled-sidebar')}>
                        <Link href="/workingOrders" title="Working Orders">
                          <span data-localize="sidebar.nav.WORKING_ORDERS"><Translate value="working_orders" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('newWorkingOrders') ? 'active' : '') + ((checkPermission('view_warehouse') && !isGGI) ? '' : 'disabled-sidebar')}>
                        <Link href="/inventoryConvert" title="New Working Orders">
                          <span data-localize="sidebar.nav.NEW_WORKING_ORDERS"><Translate value="new_working_orders" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('adjustmentInventory') ? 'active' : '') + (checkPermission('view_warehouse') ? '' : 'disabled-sidebar')}>
                        <Link href="/adjustmentInventory" title="Inventory Adjustment">
                          <span data-localize="sidebar.nav.INVENTORY_ADJUSTMENT"><Translate value="inventory_adjustment" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('shelfLifeStatistics') ? 'active' : '') + (checkPermission('view_shelf_life_statistics') ? '' : 'disabled-sidebar')}>
                        <Link href="/shelfLifeStatistics" title="Shelf Life Statistics">
                          <span data-localize="sidebar.nav.SHELFLIFESTATISTICS"><Translate value="shelf_life_statistics" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {
                  !isWIZ &&
                  <li className={ getActiveClassName(this.routeActive(dispatchList)) }>
                    <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'dispatch') }>
                      <em className="fa fa-truck"></em>
                      <span data-localize="sidebar.nav.MENU"><Translate value="dispatch" /></span>
                    </div>
                    <Collapse in={ this.state.collapse.dispatch } timeout={ 100 }>
                      <ul id="quote" className="nav sidebar-subnav">
                        <li className="sidebar-subnav-header"><Translate value="dispatch" /></li>
                        <li className={(this.routeActive('routing') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                          <Link to="/routing" title="Routing">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value="routing" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('autoRouting') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                          <Link to="/autoRouting" title="Auto Routing">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value="auto_routing" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('editRoutes') ? 'active' : '') + (checkPermission('view_edit_route') ? '' : 'disabled-sidebar')}>
                          <Link to="/editRoutes" title="Edit Route">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value="edit_route" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('shipping') ? 'active' : '') + (checkPermission('view_shipping') ? '' : 'disabled-sidebar')}>
                          <Link to="/shipping" title="Shipping">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value="shipping" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('drivers') ? 'active' : '') + (checkPermission('view_routing') ? '' : 'disabled-sidebar')}>
                          <Link to="/drivers" title="Drivers">
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value="drivers" /></span>
                          </Link>
                        </li>
                      </ul>
                    </Collapse>
                  </li>
                }
                <li className={ getActiveClassName(this.routeActive(ARAPList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'ARAP') }>
                    <em className="fa fa-credit-card"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="ar_slashsign_ap" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.ARAP } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="AR" /></li>
                      {(isSV || isNS ) && <li className={(this.routeActive('glform/new') ? 'active' : '') + (checkPermission('view_gl') ? '' : 'disabled-sidebar')}>
                        <Link href="/glform/new" title="General Ledger Form">
                          <span data-localize="sidebar.nav.GLFORM"><Translate value="gl_form"/></span>
                        </Link>
                      </li>}
                      {(isSV || isNS ) && <li className={(this.routeActive('glList') ? 'active' : '') + (checkPermission('view_gl') ? '' : 'disabled-sidebar')}>
                        <Link to="/glList" title="General Ledger">
                          <span data-localize="sidebar.nav.GL"><Translate value="gl_list"/></span>
                        </Link>
                      </li>}
                      <li className={(this.routeActive('AR') ? 'active' : '') + (checkPermission('view_account_receivable') ? '' : 'disabled-sidebar')}>
                        <Link href="/AR" title="Accounts Receivable">
                          <span data-localize="sidebar.nav.AR"><Translate value="account_receivable" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('AP') ? 'active' : '') + (checkPermission('view_account_payable') ? '' : 'disabled-sidebar')}>
                        <Link href="/AP" title="Accounts Payable">
                          <span data-localize="sidebar.nav.AP"><Translate value="account_payable" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('/paymentSummary') ? 'active' : '') + (checkPermission('view_payment_summary') ? '' : 'disabled-sidebar')}>
                        <Link href="/paymentSummary" title="Payment Summary">
                          <span data-localize="sidebar.nav.AP"><Translate value="payment_summary" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('purchasePayment') ? 'active' : '') + (checkPermission('view_purchase_payment') ? '' : 'disabled-sidebar')}>
                        <Link to="/purchasePayment" title="Purchase Report">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="purchase_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('arSalesInvoice') ? 'active' : '') + ((checkPermission('view_sales_invoice') && !isOLG && !isGGI) ? '' : 'disabled-sidebar')}>
                        <Link to="/arSalesInvoice" title="Sales Invoice">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="sales_invoice" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('salesInvoicePayment') ? 'active' : '') + (checkPermission('view_sales_report') ? '' : 'disabled-sidebar')}>
                        <Link to="/salesInvoicePayment" title="Sales Report">
                          <span data-localize="sidebar.nav.PAYMENT"><Translate value="sales_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('generalReport') ? 'active' : '') + (checkPermission('view_general_report') ? '' : 'disabled-sidebar')}>
                        <Link to="/generalReport" title="General Report">
                      <span data-localize="sidebar.nav.PERFORMANCE"><Translate value={((isLAP || isAPD)) ? "pl_report" : "general_report"} /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('customerStatementMain') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerStatementMain" title="AR Aged Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="ar_aged_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('vendorStatementMain') ? 'active' : '') + (checkPermission('view_vendor_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendorStatementMain" title="AP Aged Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="ap_aged_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('customerStatement') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerStatement" title="Customer Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="customer_statement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('vendorStatement') ? 'active' : '') + (checkPermission('view_vendor_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendorStatement" title="Vendor Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="vendor_statement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('cityReport') ? 'active' : '') + (checkPermission('view_city_report') ? '' : 'disabled-sidebar')}>
                        <Link to="/cityReport" title="City Report">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="city_report" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('mobileCustomerStatement') ? 'active' : '') + (checkPermission('view_customer_statement') ? '' : 'disabled-sidebar')}>
                        <Link to="/mobileCustomerStatement" title="Mobile Customer Statement">
                          <span data-localize="sidebar.nav.PERFORMANCE"><Translate value="mobile_customer_statement" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {!isWIZ &&
                <li className={ getActiveClassName(this.routeActive(returnsList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'returns') }>
                    <em className="fa fa-backward"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="returns" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.returns } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="returns" /></li>
                      <li className={(this.routeActive('customerReturn') ? 'active' : '') + (checkPermission('view_sales_return') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerReturn" title="New Sales Return">
                          <span><Translate value="new_sales_return" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('inventoryReturn') ? 'active' : '') + (checkPermission('view_sales_return') ? '' : 'disabled-sidebar')}>
                        <Link to="/inventoryReturn" title="Sales Return">
                          <span><Translate value="sales_return" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                }
                {!isWIZ &&
                <li className={ getActiveClassName(this.routeActive(posManagementList)) }>
                    <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'posManagement') }>
                      <em className="fa fa-bar-chart"></em>
                      <span data-localize="sidebar.nav.MENU"><Translate value="pos_management" /></span>
                    </div>
                    <Collapse in={ this.state.collapse.posManagement } timeout={ 100 }>
                      <ul id="quote" className="nav sidebar-subnav">
                        <li className="sidebar-subnav-header"><Translate value="pos_management" /></li>
                        <li className={(this.routeActive('POS') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                          <Link to="/pos" title="POS">
                            <span><Translate value="pos" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('POSReport') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                          <Link to="/posReport" title="POS Report">
                            <span><Translate value="pos_report" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('POSOrders') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                          <Link to="/posOrders" title="POS Orders">
                            <span data-localize="sidebar.nav.POSORDERS"><Translate value="pos_order" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('POSCredits') ? 'active' : '') + (checkPermission('view_pos') ? '' : 'disabled-sidebar')}>
                          <Link to="/posCredits" title="POS Credits">
                            <span data-localize="sidebar.nav.CREDITS"><Translate value="pos_credit" /></span>
                          </Link>
                        </li>
                        <li className={(this.routeActive('POSHold') ? 'active' : '')}>
                          <Link to="/posHolds" title="POS Holds">
                            <span data-localize="sidebar.nav.HOLDS"><Translate value="pos_holds" /></span>
                          </Link>
                        </li>
                        {isGFD &&
                         <li className={(this.routeActive('giftCardTransaction') ? 'active' : '')}>
                         <Link href="/giftCardTransaction" title="Gift Card Transactions">
                           <span data-localize="sidebar.nav.GIFTCARD"><Translate value="gift_card_transactions" /></span>
                         </Link>
                       </li>
                        }
                      </ul>
                    </Collapse>
                  </li>
                }
                <li className={ getActiveClassName(this.routeActive(generalInformationList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'generalInformation') }>
                    <em className="icon-book-open"></em>
                    <span data-localize="sidebar.nav.MENU"><large><Translate value="general_management" /></large></span>
                  </div>
                  <Collapse in={ this.state.collapse.generalInformation } timeout={ 100 }>
                    <ul id="products" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="general_information" /></li>
                      <li className={(this.routeActive('products') ? 'active' : '') + (checkPermission('view_product') ? '' : 'disabled-sidebar')}>
                        <Link to="/products" title="Product">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="product" /></span>
                        </Link>
                      </li>
                      {isVAK && this.props.company && this.props.company.value == 6 && <li className={(this.routeActive('productsMapping') ? 'active' : '') + (checkPermission('view_skumap') ? '' : 'disabled-sidebar')}>
                        <Link href="/productMapping" title="ProductMapping">
                          <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="product_mapping" /></span>
                        </Link>
                      </li>}
                      <li className={(this.routeActive('customers') ? 'active' : '') + (checkPermission('view_customer') ? '' : 'disabled-sidebar')}>
                        <Link to="/customers" title="Customers">
                          <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="customers" /></span>
                        </Link>
                      </li>
                      {isGGI && <li className={(this.routeActive('marketing') ? 'active' : '') + (checkPermission('view_marketing') ? '' : 'disabled-sidebar')}>
                        <Link to="/marketing" title="Marketing">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="marketing" /></span>
                        </Link>
                      </li>}
                      <li className={(this.routeActive('vendors') ? 'active' : '') + (checkPermission('view_vendor') ? '' : 'disabled-sidebar')}>
                        <Link to="/vendors" title="Vendor">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="vendor" /></span>
                        </Link>
                      </li>
                      {/* <li className={(this.routeActive('contentManagement') ? 'active' : '') + (checkPermission('view_content_management') ? '' : 'disabled-sidebar')}>
                          <Link to="/contentManagement" title="contentManagement">
                              <span data-localize="sidebar.nav.SINGLEVIEW"><Translate value="content_management" /></span>
                          </Link>
                      </li> */}
                      <li className={(this.routeActive('agents') ? 'active' : '') + (checkPermission('view_agent') ? '' : 'disabled-sidebar')}>
                        <Link to="/agentManagement" title="Agents">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="agents" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('paymentTerms') ? 'active' : '') + (checkPermission('view_payment_term') ? '' : 'disabled-sidebar')}>
                        <Link to="/paymentTerms" title="Payment Term">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="payment_term" /></span>
                        </Link>
                      </li>
                      {/* <li className={(this.routeActive('contentManagement') ? 'active' : '') + (checkPermission('view_content_management') ? '' : 'disabled-sidebar')}>
                        <Link href="/contentManagement" title="Content Management">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="content_management" /></span>
                        </Link>
                      </li> */}
                      <li className={(this.routeActive('fbaAddressManagement') ? 'active' : '') + ((checkPermission('view_content_management') && !isOLG && !isGGI) ? '' : 'disabled-sidebar')}>
                        <Link href="/fbaAddressManagement" title="FBA Address Management">
                          <span data-localize="sidebar.nav.SALESINVOICE"><Translate value="fbaAddressManagement" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('products/groups') ? 'active' : '') + (checkPermission('view_product_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/products/groups" title="Product Group">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value={isJTB ? "customer_groups" : "groups_management"} /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('priceLevel') ? 'active' : '') + (checkPermission('view_price_level') ? '' : 'disabled-sidebar')}>
                        <Link to="/priceLevel" title="Price Level">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="price_level" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('mobileManagement') ? 'active' : '') + (checkPermission('view_product_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/mobileManagement" title="Mobile Management">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="mobile_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('categoryAnalysis') ? 'active' : '') + (checkPermission('view_category_analysis') ? '' : 'disabled-sidebar')}>
                        <Link to="/categoryAnalysis" title="Category Analysis">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="category_analysis"/></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('presidentDashboard') ? 'active' : '') + (checkPermission('view_dashboard_president') ? '' : 'disabled-sidebar')}>
                        <Link to="/presidentDashboard" title="President Dashboard">
                          <span data-localize="sidebar.nav.PRODUCTS"><Translate value="president_dashboard" /></span>
                        </Link>
                      </li>
                      {(isSV || isNS )&& <li className={(this.routeActive('generalLedger') ? 'active' : '') + (checkPermission('view_general_ledger') ? '' : 'disabled-sidebar')}>
                        <Link href="/GL" title="General Ledger">
                          <span data-localize="sidebar.nav.GL"><Translate value="general_ledger" /></span>
                        </Link>
                      </li>}
                      {
                        (isOCM || isOLG || isGGI) &&
                        <li className={(this.routeActive('packers') ? 'active' : '')}>
                          <Link to="/packers" title={(isOLG || isGGI)?"Pickers":"Packers"}>
                            <span data-localize="sidebar.nav.SALESORDERS"><Translate value={(isOLG || isGGI)?"pickers":"packers"} /></span>
                          </Link>
                        </li>
                      }
                    </ul>
                  </Collapse>
                </li>
                <li className={ getActiveClassName(this.routeActive(rmaList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'rma') }>
                    <em className="fa fa-recycle"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="rma" /></span>
                  </div>
                  <Collapse in={this.state.collapse.rma} timeout={100}>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                      <li className={(this.routeActive('customerRMA') ? 'active' : '') + (checkPermission('view_bd_rma_customer') ? '' : 'disabled-sidebar')}>
                        <Link to="/customerRMA" title="RMA Form">
                          <span data-localize="sidebar.nav.RMAFORM"><Translate value="customer_rma" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('dispatchRMA') ? 'active' : '') + (checkPermission('view_bd_rma') ? '' : 'disabled-sidebar')}>
                        <Link to="/dispatchRMA" title="Dispatch RMA">
                          <span data-localize="sidebar.nav.DISPATCHRMA"><Translate value="dispatch_rma" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {!isRebuild &&
                <li className={ getActiveClassName(this.routeActive(settingList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'setting') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="admin_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.setting } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                      <li className={(this.routeActive('userManagement') ? 'active' : '') + (checkPermission('view_baseuser') ? '' : 'disabled-sidebar')}>
                        <Link to="/userManagement" title="User Management">
                          <span data-localize="sidebar.nav.USERMANAGEMENT"><Translate value="user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupManagement') ? 'active' : '') + (checkPermission('view_group') ? '' : 'disabled-sidebar')}>
                        <Link to="/groupManagement" title="Role Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="role_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('taxManagement') ? 'active' : '') + (checkPermission('view_tax_area') ? '' : 'disabled-sidebar')}>
                        <Link to="/taxManagement" title="Tax Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="tax_management" /></span>
                        </Link>
                      </li>
                      {isWAK && <li className={(this.routeActive('rateManagement') ? 'active' : '') + (checkPermission('view_rate_manage') ? '' : 'disabled-sidebar')}>
                        <Link href="/rateManagement" title="Rate Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="rate_management" /></span>
                        </Link>
                      </li>}
                      <li className={(this.routeActive('currencyManagement') ? 'active' : '') + (checkPermission('view_currency') ? '' : 'disabled-sidebar')}>
                        <Link to="/currencyManagement" title="Currency Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="currency_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('actionLog') ? 'active' : '') + ((isGGI && (checkPermission('view_action_log')) || !isGGI)? '' : 'disabled-sidebar')}>
                        <Link to="/actionLog" title="Action Log">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="action_log" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                }
                {isRebuild &&
                <li className={ getActiveClassName(this.routeActive(settingList)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'setting') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="admin_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.setting } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="setting" /></li>
                       <li className={(this.routeActive('scmUserManagement') ? 'active' : '') + ((checkPermission('view_baseuser') && true) ? '' : 'disabled-sidebar')}>
                        <Link href="/scmUserManagement" title="SCM User Management">
                          <span data-localize="sidebar.nav.SCMUSERMANAGEMENT"><Translate value="scm_user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('userManagement') ? 'active' : '') + (checkPermission('view_baseuser') ? '' : 'disabled-sidebar')}>
                        <Link to="/userManagement" title="User Management">
                          <span data-localize="sidebar.nav.USERMANAGEMENT"><Translate value="mobile_user_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('groupManagement') ? 'active' : '') + (checkPermission('view_group') ? '' : 'disabled-sidebar')}>
                        <Link href="/groupManagement" title="Role Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="role_management" /></span>
                        </Link>
                      </li>
                      <li className={(this.routeActive('taxManagement') ? 'active' : '') + (checkPermission('view_tax_area') ? '' : 'disabled-sidebar')}>
                        <Link href="/taxManagement" title="Tax Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="tax_management" /></span>
                        </Link>
                      </li>
                      {isWAK && <li className={(this.routeActive('rateManagement') ? 'active' : '') + (checkPermission('view_rate_manage') ? '' : 'disabled-sidebar')}>
                        <Link href="/rateManagement" title="Rate Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="rate_management" /></span>
                        </Link>
                      </li>}
                      {/* <li className={(this.routeActive('currencyManagement') ? 'active' : '') + (checkPermission('view_currency') ? '' : 'disabled-sidebar')}>
                        <Link to="/currencyManagement" title="Currency Management">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="currency_management" /></span>
                        </Link>
                      </li> */}
                      <li className={(this.routeActive('actionLog') ? 'active' : '') + ((isGGI && (checkPermission('view_action_log')) || !isGGI)? '' : 'disabled-sidebar')}>
                        <Link href="/actionLog" title="Action Log">
                          <span data-localize="sidebar.nav.ROLEMANAGEMENT"><Translate value="action_log" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                }
                <li className={ getActiveClassName(this.routeActive(MMdriverList)) }>
                  <Link to="/mmdriver" title="MMdriver">
                    <em className="fa fa-truck"></em>
                    <span data-localize="sidebar.nav.RMAFORM"><Translate value="MMdriver" /></span>
                  </Link>
                </li>
                <li className={ getActiveClassName(this.routeActive(aiTools)) }>
                  <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'aiTools') }>
                    <em className="fa fa-cog"></em>
                    <span data-localize="sidebar.nav.MENU"><Translate value="ai_tools" /></span>
                  </div>
                  <Collapse in={ this.state.collapse.aiTools } timeout={ 100 }>
                    <ul id="quote" className="nav sidebar-subnav">
                      <li className="sidebar-subnav-header"><Translate value="ai_tools" /></li>
                       <li className={(this.routeActive('aiChat') ? 'active' : '') + (checkPermission('view_ai') ? '' : 'disabled-sidebar')}>
                        <Link href="/aiChat" title="AI CHAT">
                          <span data-localize="sidebar.nav.AICHAT"><Translate value="ai_chat" /></span>
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                {/* <li className={ this.routeActive(['priceAdjustment', 'productConvert', 'purchasePivot', 'purchaseReference', 'purchasePerformance', 'salesPerformance']) ? 'active' : '' }>
                      <div className="nav-item" onClick={ this.toggleItemCollapse.bind(this, 'report') }>
                        <em className="fa fa-file-text-o"></em>
                        <span data-localize="sidebar.nav.MENU"><Translate value="report" /></span>
                      </div>
                      <Collapse in={ this.state.collapse.report } timeout={ 100 }>
                        <ul id="report" className="nav sidebar-subnav">
                          <li className="sidebar-subnav-header"><Translate value="report" /></li>
                          <li className={ this.routeActive('priceAdjustment') ? 'active' : '' }>
                            <Link to="/priceAdjustment" title="price_adjustment">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="price_adjustment" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('productConvert') ? 'active' : '' }>
                            <Link to="/productConvert" title="product_convert">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="product_convert" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('purchasePivot') ? 'active' : '' }>
                            <Link to="/purchasePivot" title="purchase_pivot">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="purchase_pivot" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('purchaseReference') ? 'active' : '' }>
                            <Link to="/purchaseReference" title="purchase_reference">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="purchase_reference" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('purchasePerformance') ? 'active' : '' }>
                            <Link to="/purchasePerformance" title="purchase_performance">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="purchase_performance" /></span>
                            </Link>
                          </li>
                          <li className={ this.routeActive('salesPerformance') ? 'active' : '' }>
                            <Link to="/salesPerformance" title="sales_performance">
                              <span data-localize="sidebar.nav.REPORT"><Translate value="sales_performance" /></span>
                            </Link>
                          </li>
                        </ul>
                      </Collapse>
                  </li> */}
              </ul>
              { /* END sidebar nav */ }
            </nav>
          </div>
          { /* END Sidebar (left) */ }
        </aside>
      );
    }

    render() {
      if (isESC) {
        return this.renderESCAside()
      }
      return this.renderDefaultAside()
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/Sidebar.jsx